// https://www.shecodes.io/athena/4901-how-to-create-a-dropdown-component-in-react

import React from 'react';
import cx from './styles.less';

export interface DropDownItemBasic {
    key: number;
    name: string;
    statusclass?: string; 
    prefix: string;   
}

class DropDownBasic extends React.Component<any, any> {
    items = this.props.items;
    itemSelection = this.props.itemSelection;
    showDropDown=this.props.showDropDown;
    toggleDropDown=this.props.toggleDropDown;
    prefix = this.props.prefix;
    value=this.props.value;
    label=this.props.label;
    extraclass = this.props.extraclass;
    
    onChange = (e: any): void => {
        var selected = this.props.value ? 
                        (this.items as DropDownItemBasic[]).qWhere((o: DropDownItemBasic) => o.name.toLowerCase()===e.target.value.toLowerCase()).qFirst():
                        (this.items as DropDownItemBasic[]).qFirst();      
        this.itemSelection(selected?selected.key:1);
    }

    onToggle = (): void => {
        this.toggleDropDown();
    }

    renderOptions() {
        const options = this.items.map((option: any) => {
            return (
                <option key={option.key} value={option.name} className={cx(option.statusclass)}>
                    {option.name}
                </option>
            );
        });
        return options;
    }

    render() {

        var selectedOption = this.props.value ? 
                            (this.items as DropDownItemBasic[]).qWhere((o: DropDownItemBasic) => o.key===this.props.value).qFirst():
                             (this.items as DropDownItemBasic[]).qFirst(); 

        // const display = 'block';
        return (
            <div className={cx('dropdown-status')}>
                <div className={cx('trigger')} onClick={this.onToggle}>
                    { this.props.title }
                </div>
                <div className={cx('options-list')}>
                    <select                    
                        value={selectedOption ? selectedOption.name: ''} 
                        onChange={this.onChange}
                        className={cx(this.extraclass, (selectedOption ? this.prefix + selectedOption.key.toString() : this.prefix))}>
                            {this.renderOptions()}
                    </select>
                </div>
            </div>
        );
    }
}

export default DropDownBasic;



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/react-toolbox-extended/dropdownbasic.tsx